import classNames from "classnames";
import type React from "react";
import { memo } from "react";
import { SegmentUrlListItemContainer } from "./SegmentUrlListStyles";
import type { ISegmentUrlListItemHighlightProps } from "app/pages/segments/redesigned-wizard/segment-wizard/types";

const SegmentUrlListItemComponent: React.FunctionComponent<ISegmentUrlListItemHighlightProps> = ({
    urlHighlighted,
}) => {
    return (
        <SegmentUrlListItemContainer>
            {urlHighlighted.map(({ partTypes, text, isShrink }, i) => (
                <span
                    key={i}
                    className={classNames(Array.from(partTypes), { shrinked: isShrink })}
                >
                    {text}
                </span>
            ))}
        </SegmentUrlListItemContainer>
    );
};

export const SegmentUrlListItem = memo(SegmentUrlListItemComponent);
